jQuery(function ($) {

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function initCTA($block) {
    const $bgImage = $block.find('.cta__bg-media--image');
    const isParallax = $block.hasClass('cta--parallax');
    const speed = parseFloat($block.css('--cta-parallax-speed')) || 0.25;

    // Parallax for bg image
    function onScroll() {
      if (!isParallax || !$bgImage.length) return;

      const rect = $block[0].getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      // progress from -1 to 1
      const mid = rect.top + rect.height / 2;
      const t = (mid - vh / 2) / (vh / 2);
      const prog = clamp(t, -1, 1);

      // translate up/down subtly
      const move = prog * 40 * speed; // px
      $bgImage.css('transform', 'translate3d(0,' + move + 'px,0)');
    }

    if (isParallax) {
      $(window).on('scroll.cta resize.cta', onScroll);
      onScroll();
    }

    // Background lottie container hook (if your lottie-player component auto-inits, you can ignore this)
    const $bgLottie = $block.find('.cta__bg-media--lottie');
    if ($bgLottie.length) {
      // If you already initialize lottie globally, do nothing.
      // This is intentionally minimal.
      // Example: data-lottie-url is available for your existing initializer.
    }
  }

  $('.block-module-cta').each(function () {
    initCTA($(this));
  });

});
